import React from 'react';
export function JolenaIntro() {
  return <div className="w-full my-12 p-8 bg-gradient-to-r from-purple-100 to-teal-100 rounded-xl shadow-lg" data-id="element-228">
      <div className="max-w-3xl mx-auto" data-id="element-229">
        <div className="flex flex-col md:flex-row items-center gap-6 mb-8" data-id="element-230">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wXt2gdvZfqjBsG4s5bFsem/Mockups_%2817%29.png" alt="Jolena Nicol" className="w-32 h-32 rounded-full object-cover shadow-md" data-id="element-231" />
          <div data-id="element-232">
            <p className="text-xl text-gray-700 mb-2" data-id="element-233">
              Hi, my name is Jolena Nicol.
            </p>
            <p className="text-xl text-gray-700 font-bold" data-id="element-234">
              I still remember the first time a client told me she couldn't feel
              anything. Not sadness, not anger, not even joy.
            </p>
          </div>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-5 text-center" data-id="element-235">
          She looked right at me and quietly said, "I'm numb. Completely numb.
          And nothing I've tried helps."
        </h2>
        <div className="text-lg text-gray-700 space-y-4" data-id="element-236">
          <p data-id="element-237">
            At the time, I'd already been a therapist and creative expression
            coach for several years, helping hundreds of clients move through
            emotional blocks using neuroscience-informed art, sound, and
            movement. But this felt different.
          </p>
          <p data-id="element-238">
            She wasn't anxious. She wasn't spiraling. She wasn't visibly
            overwhelmed.
          </p>
          <p data-id="element-239">She was frozen.</p>
          <p data-id="element-240">More and more clients began quietly sharing the same story:</p>
          <p data-id="element-241">
            They'd been in therapy for years. They'd journaled. Meditated. Tried
            breathwork, yoga, medication… everything.
          </p>
          <p data-id="element-242">
            But beneath the surface, they felt empty. Disconnected. Unable to
            access their emotions, unable to cry—even when life hurt.
          </p>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 my-6 text-center" data-id="element-243">
          The worst part wasn't feeling anxious or sad. It was feeling nothing
          at all.
        </h2>
        <div className="text-lg text-gray-700 space-y-4" data-id="element-244">
          <p data-id="element-245">That's when I realized something crucial:</p>
          <p data-id="element-246">
            All these traditional tools are great—but they don't always reach
            the nervous system when it's stuck in freeze.
          </p>
          <p data-id="element-247">
            It was time to find something gentler. Something creative. Something
            body-based and safe enough to reach the parts of the nervous system
            that words alone can't touch.
          </p>
          <p data-id="element-248">And when we finally did, everything changed.</p>
          <p className="font-bold" data-id="element-249">
            I watched clients who hadn't felt joy in years finally reconnect
            with laughter.
          </p>
          <p data-id="element-250">
            I saw people who'd been numb for decades slowly begin to cry—and
            feel relief. I watched faces soften and voices return, as they
            gently moved out of freeze and back toward feeling fully alive
            again.
          </p>
          <p data-id="element-251">
            That's exactly why I'm here today… To show you a different way
            forward.
          </p>
          <p data-id="element-252">
            No matter how long you've felt numb, disconnected, or emotionally
            frozen…
          </p>
          <p data-id="element-253">You're not stuck there forever.</p>
          <p data-id="element-254">You see…</p>
        </div>
      </div>
    </div>;
}